/*
 *
 * CabinetOptions actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';

export const fixToWallAction = (value: boolean) =>
  action(ActionTypes.FIX_TO_WALL, { value });
